import styled from 'styled-components'

import ActiveIcBg from './active-ico.svg'

export const Container = styled.li<{ $isActive: boolean }>`
  border: 2px solid ${({ theme, $isActive }) => ($isActive ? theme.colors.input.active : theme.colors.input.border)};
  background: ${({ theme, $isActive }) => ($isActive ? '#E7F3FB' : theme.colors.input.white)};
  border-radius: 999px;
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Label = styled.span`
  flex: 2;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`

export const ActiveIco = styled.span`
  height: 16px;
  width: 16px;
  background: url(${ActiveIcBg}) no-repeat;
  background-size: 16px 16px;
  margin-left: 5px;
`
